import { render, staticRenderFns } from "./OnlineBookingsList.vue?vue&type=template&id=7880322e"
import script from "./OnlineBookingsList.vue?vue&type=script&lang=js"
export * from "./OnlineBookingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports